import { BaseRoutes } from './base.routes.constants';

export class AntecipacaoConfirmationAllRoutes extends BaseRoutes {
  constructor(route: string) {
    super(route);
  }
}
